import { createReducer, on } from '@ngrx/store';
import { SyriaBoundaryState } from '../states/syria-boundary.state';
import {
  loadSyriaBoundary,
  loadSyriaBoundaryFailure,
  loadSyriaBoundarySuccess,
} from '../actions/syria-boundary.actions';

export const initialState: SyriaBoundaryState = {
  boundary: null,
  loading: false,
  error: null,
};

export const syriaBoundaryReducer = createReducer(
  initialState,
  on(loadSyriaBoundary, (state) => ({
    ...state,
    loading: true,
  })),
  on(loadSyriaBoundarySuccess, (state, { boundary }) => ({
    ...state,
    loading: false,
    boundary,
  })),
  on(loadSyriaBoundaryFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
